import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import WelcomeHeader from 'components/layout/WelcomeHeader/index'
import { Form } from 'antd'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { getStoredSessionId } from 'utils/cliAuthSession'
import WelcomeForm from './form'
import constants from '../../../constants'

const Welcome = () => {
  const [name, setName] = useState('')

  const [password, setPassword] = useState('')
  const location = useLocation()
  const urlParams = _.split(location.pathname, '/')
  const { search } = useLocation()
  const [userContactNumber, setUserContactNumber] = useState('')

  const [userCountryCode, setUserCountryCode] = useState('us')
  const [invitedAppID, setInvitedAppID] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const dispatch = useDispatch()

  const [form] = Form.useForm()

  useEffect(() => {
    const searchParams = new URLSearchParams(search)
    const invitedApp = searchParams.get('invitedApp')
    setInvitedAppID(invitedApp)
  }, [search])

  const afterSignUpEvents = ({ error, cancelled, data }) => {
    if (!error && !cancelled && data.data) {
      if (constants.captureGTMEvents && window.CometChatAnalytics) {
        window.CometChatAnalytics.event(constants.GAEvents.user_signup)

        window.partnerStackSignUp(data.data)
      }
    }
  }

  const onFinish = () => {
    const values = form.getFieldsValue(true)

    if (isPasswordValid) {
      if (
        values.password.charAt(0) === ' ' ||
        values.password.charAt(values.password.length - 1) === ' '
      ) {
        dispatch({
          type: 'apps/INITIATE_NOTIFICATION',
          payload: {
            type: 'error',
            message: 'Your password can’t start or end with a blank space',
          },
        })
        return
      }
      if (userContactNumber !== '') {
        values.contactNumber = userContactNumber
        values.countryCode = userCountryCode
      } else {
        delete values.contactNumber
      }
      dispatch({
        type: 'user/SIGN_UP',
        payload: { ...values, showModal: true, invitedApp: invitedAppID },
        onComplete: result => {
          afterSignUpEvents(result)
        },
      })
    } else {
      dispatch({
        type: 'apps/INITIATE_NOTIFICATION',
        payload: { type: 'error', message: 'Not a strong Password' },
      })
    }
  }

  const isCliAuthFlow = !!getStoredSessionId()

  return (
    <>
      <WelcomeHeader step={isCliAuthFlow ? null : 1} totalSteps={isCliAuthFlow ? null : 7} />
      <div
        style={{
          width: '100%',
          padding: '0 10px',
          borderRadius: '10px',
          backgroundColor: '#F9F9F9',
        }}
      >
        <div style={{ border: '1px solid #E9EAEB', borderRadius: '10px', backgroundColor: '#FFF' }}>
          <div style={{ padding: '14px', minHeight: '64px' }} />
          <Form
            form={form}
            colon={false}
            hideRequiredMark
            initialValues={{
              prefilledEmail: atob?.(urlParams?.[4]),
              password,
              name,
              contactNumber: userContactNumber,
            }}
          >
            <WelcomeForm
              nextStep={onFinish}
              form={form}
              password={password}
              setPassword={setPassword}
              name={name}
              userContactNumber={userContactNumber}
              setIsPasswordValid={setIsPasswordValid}
              isPasswordValid={isPasswordValid}
              setName={setName}
              setUserContactNumber={setUserContactNumber}
              userCountryCode={userCountryCode}
              setUserCountryCode={setUserCountryCode}
              isCliAuthFlow={isCliAuthFlow}
            />
          </Form>
        </div>
      </div>
    </>
  )
}

export default Welcome
